const Textareawithlable = ({
    className,
    type,
    value,
    name,
    id,
    placeHolder,
    handleChange,
    error,
    labelName,
    showastrict=false,
    lableclassName,
    disabled
  }) => {
    return (
      <div>
        <div className="input-container">
          <label className={lableclassName}>
            {labelName} {showastrict && <span className="text-danger">*</span>}
          </label>
          <textarea
            required
            type={type}
            name={name}
            value={value}
            className={`form-control p-20 ${className} ${
              error && "border-danger bg-error"
            }`}
            placeholder={placeHolder}
            onChange={handleChange}
            disabled={disabled}  
          />
        </div>
      </div>
    );
  };
  
  export default Textareawithlable;
  